
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 19.167a9.109 9.109 0 01-6.482-2.685 9.103 9.103 0 01-2.685-6.481c0-2.449.954-4.75 2.685-6.482A9.104 9.104 0 0110 .833c2.45 0 4.75.954 6.482 2.686A9.105 9.105 0 0119.167 10c0 2.449-.954 4.75-2.685 6.481A9.104 9.104 0 0110 19.167zm0-17.369c-4.522 0-8.202 3.68-8.202 8.202 0 4.523 3.68 8.202 8.202 8.202 4.523 0 8.202-3.68 8.202-8.202 0-4.523-3.68-8.202-8.202-8.202z","fill":"#316833"}}),_c('path',{attrs:{"d":"M8.07 13.86a.485.485 0 01-.341-.141l-2.895-2.895a.483.483 0 01.682-.682l2.554 2.553 6.412-6.413a.483.483 0 01.683.682L8.41 13.72a.482.482 0 01-.341.14h.001z","fill":"#316833"}})])
          )
        }
      }
    